// ICM scroll-reveal: fades/rises .icm-reveal elements into view once.
// Vanilla JS, no jQuery dependency. Pairs with .icm-reveal / .is-visible
// in assets/icm-foundation.css.liquid.
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.add('icm-no-io');
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  var targets = document.querySelectorAll('.icm-reveal');
  for (var i = 0; i < targets.length; i++) {
    observer.observe(targets[i]);
  }
})();
